var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ocr-results-overlay",attrs:{"id":"ocr-results-container"}},[_c('div',{ref:"results",staticClass:"ocr-results-overlay__results"}),_c('ocr-progress-dialog',{ref:"dialog",attrs:{"progress":_vm.progress},on:{"cancel":_vm.onClickCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }